var React = require('react');

function ArrowRight100 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2 15L102 15","stroke":"#454553","strokeWidth":"3","strokeMiterlimit":"10","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M89 2L101.632 14.866","stroke":"#454553","strokeWidth":"3","strokeMiterlimit":"10","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M89 27.7471L101.632 14.866","stroke":"#454553","strokeWidth":"3","strokeMiterlimit":"10","strokeLinecap":"round","key":2})]);
}

ArrowRight100.defaultProps = {"width":"104","height":"30","viewBox":"0 0 104 30","fill":"none"};

module.exports = ArrowRight100;

ArrowRight100.default = ArrowRight100;
